<a [routerLink]="track?.route || null">
  <img *ngIf="track?.source === AudioPlayerTrackSource.INBOX" [src]="track.id | inboxArtwork | async" alt="artwork" onerror="this.src='assets/img/no-artwork.png'">
  <abcdj-track-artwork *ngIf="track?.source === AudioPlayerTrackSource.TRACK" [trackId]="track.id" [format]="ImagePreset.THUMBNAIL" />
</a>
